import { AxiosRequestConfig } from 'axios'

import apiPath from '../constant/api-path'
import axios from '../utils/axios'

export const getAccountData = () => {
  const config: AxiosRequestConfig & { useNewAPI: boolean } = {
    useNewAPI: true
  }

  return axios.get(apiPath.GET_ACCOUNT, config)
}

export const getBankAccounts = () => axios.get(apiPath.GET_BANK_ACCOUNT)

export const getAccountStatus = () => axios.get(apiPath.GET_ACCOUNT_STATUS)

export const getUsersProfile = () => axios.get(apiPath.GET_USER_PROFILE)

export const getGenerateHash = () => {
  const config: AxiosRequestConfig & { useNewAPI: boolean } = {
    useNewAPI: true
  }

  return axios.get(apiPath.GENERATE_HASH, config)
}

export const closePopup = () => {
  const config: AxiosRequestConfig & { useNewAPI: boolean } = {
    useNewAPI: true
  }

  return axios.get(apiPath.PUBLIC_INVESTOR_POPUP_CLOSE, config)
}

export const getInvestorBankList = () => {
  const config: AxiosRequestConfig & { useNewAPI: boolean } = {
    useNewAPI: true
  }

  return axios.get(apiPath.GET_INVESTORS_BANK_LIST, config)
}

export const getServerTime = () => {
  const config: AxiosRequestConfig & { useNewAPI: boolean } = {
    useNewAPI: true
  }

  return axios.get(apiPath.GET_SERVER_TIME, config)
}
